import { render, staticRenderFns } from "./controllers.vue?vue&type=template&id=240a0366&scoped=true&lang=pug"
import script from "./controllers.vue?vue&type=script&lang=js"
export * from "./controllers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240a0366",
  null
  
)

/* custom blocks */
import block0 from "./controllers.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports